import { AnyAction } from '@reduxjs/toolkit';
import { IQuestion } from 'types/Question.types';
import { SET_COLOR_MODAL_DATA, CLOSE_COLOR_MODAL } from '../colorModal';
import { COMPANY_CHANGED } from 'store/constants';

export interface IColorModalReducerState {
  isOpen: boolean;
  question: IQuestion | null;
}

const INIT_STATE: IColorModalReducerState = {
  isOpen: true,
  question: null,
};

const colorModalReducer = (state = INIT_STATE, action: AnyAction) => {
  switch (action.type) {
    case CLOSE_COLOR_MODAL:
      return {
        ...state,
        isOpen: false,
        question: null,
      };
    case COMPANY_CHANGED:
      // Holds a question from the configuration that was open.
      return {
        ...INIT_STATE,
      };
    case SET_COLOR_MODAL_DATA:
      return {
        ...state,
        isOpen: true,
        question: action.payload.question,
      };
    default:
      return state;
  }
};

export default colorModalReducer;
